import { Injectable } from '@angular/core';
import { DataService } from '../../../shared/services/data.service';
import { StorageService } from '../../../shared/services/storage.service';
import { SubscriptionList } from './subscription-list.model';
import { ResponseModel } from '../../../shared/models/response-model.model';
import { Subject, tap } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SubscriptionListService {

  constructor(public service: DataService,public storageService: StorageService) {}

  getAllSubscriptionListData(data:SubscriptionList){
    let url = `api/App/Subscription/getAllSubscription`;
    return this.service.post(url,data).pipe<ResponseModel>(tap((response: any) => {
    return response;
      })
    );
  }

  generateSubscriptionBillNo(data){
    let url = `api/App/Subscription/generateSubscriptionBillNo`;
    return this.service.post(url,data).pipe<ResponseModel>(tap((response: any) => {
    return response;
      })
    );
  }
  resetSubscriptionBillNo(data){
    let url = `api/App/Subscription/resetSubscriptionBillNo`;
    return this.service.post(url,data).pipe<ResponseModel>(tap((response: any) => {
    return response;
      })
    );
  }

  updateSubscriptionBillingDetail(data:any){
    let url = `api/App/Subscription/updateSubscriptionBillingDetail`;
    return this.service.post(url,data).pipe<ResponseModel>(tap((response: any) => {
    return response;
      })
    );
  }

  recalculateSubscriptionBillingDetail(data: any) {
    let url = `api/App/Subscription/recalculateSubscriptionDetails`;
    return this.service.post(url, data).pipe<ResponseModel>(tap((response: any) => {
      return response;
    })
    );
  }

  checkPasswordToUpdateDetail(data: any) {
    let url = `api/App/Subscription/verifySubscriptionPassword`;
    return this.service.post(url, data).pipe<ResponseModel>(tap((response: any) => {
    return response;
    })
    );
  }

}
